<div class="cb-mock-dialog">
  <button class="floating-close-button" [mat-dialog-close]>
    <svg-icon-sprite style="color:white;" [src]="'assets/images/svgIconsSprite.svg#cross'" [width]="'12px'">
    </svg-icon-sprite>
  </button>
  <div class="cb-mock-dialog-header">
    <h3 mat-dialog-title class="text-center">Manage Paid Apps</h3>
  </div>
  <mat-dialog-content>
    <div class="container cb-mock-dialog-body">
      <div class="row">
        <div class="col-sm">
          <h3>Paid Apps x {{ productionSlotCount }} </h3>
          <p>
            Your plan currently supports upto {{ productionSlotCount }} Paid apps. Buy additional Paid apps by adjusting the number below.
          </p>

          <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
            <mat-button-toggle checked="false" [disabled]="newSlotCount<=productionAppsCount"
              (click)="updateNewSlotCount(-1)">-</mat-button-toggle>
            <mat-button-toggle disabled> {{ newSlotCount }} </mat-button-toggle>
            <mat-button-toggle checked="false" (click)="updateNewSlotCount(1)">+</mat-button-toggle>
          </mat-button-toggle-group>

          <p *ngIf="blockReduceQty"> You can only reduce Paid Apps to {{ productionAppsCount }}. Move apps to Free first to be able to reduce Paid Apps. </p>

          <p *ngIf="newSlotCount>productionAppsCount">
            <span *ngIf="newSlotCount>productionSlotCount">
                You are buying {{ getAbsValue(newSlotCount-productionSlotCount) }} more Paid Apps.
            </span>
            <span *ngIf="newSlotCount<productionSlotCount">
                You are reducing Paid Apps by {{ getAbsValue(newSlotCount-productionSlotCount) }}
            </span>
          </p>

          <div mat-dialog-actions>
          <button mat-flat-button class="cb-mock-dialog-btn" [mat-dialog-close]="data"
            [disabled]="newSlotCount-productionSlotCount == 0">CONTINUE</button>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
